import { Badge, Button, Col } from 'react-bootstrap';
import { BsChevronDown, BsChevronRight } from 'react-icons/bs';
import { getAvailableSizes } from '../../hooks/useWidgetSelection';

const WidgetTypeCard = ({ widget, isExpanded, selectedCount, onToggleExpanded }) => {
  const availableSizes = getAvailableSizes(widget);
  const hasSizes = availableSizes.length > 0;
  const hasSelections = selectedCount > 0 || isExpanded;

  if (!hasSizes) {
    return null;
  }

  const cardSurfaceStyle = { minHeight: 96 };

  return (
    <Col xs="auto" className="p-0" style={{ width: 150, zIndex: 1 }}>
      <Button
        variant="dark"
        type="button"
        className={`position-relative overflow-visible w-100 h-100 text-white d-flex flex-column justify-content-between gap-1 p-2 text-start shadow-sm rounded-3 border-0 bg-base ${hasSelections ? 'border border-white border-opacity-25' : ''}`}
        style={cardSurfaceStyle}
        onClick={() => onToggleExpanded(widget.id)}
      >
        <div className="d-flex align-items-center justify-content-center" style={{ minHeight: 30 }}>
          {widget.icon && widget.icon()}
        </div>
        <div className="d-flex align-items-center gap-1">
          <span
            className="small text-truncate rounded-2 px-2 py-1 bg-primary-shadow flex-grow-1"
            style={{ fontSize: 12, lineHeight: 1.1 }}
            title={widget.displayName}
          >
            {widget.displayName}
          </span>
          {selectedCount > 0 && (
            <Badge bg="primary" pill>
              {selectedCount}
            </Badge>
          )}
          <span
            className="d-inline-flex align-items-center justify-content-center"
            style={{ width: 14, opacity: 0.95 }}
          >
            {isExpanded ? <BsChevronDown /> : <BsChevronRight />}
          </span>
        </div>
        {isExpanded ? (
          <span
            className="position-absolute start-0 end-0 mx-auto bg-base"
            style={{
              display: 'block',
              bottom: -14,
              width: '100%',
              height: 20,
              pointerEvents: 'none',
              zIndex: 1,
            }}
          />
        ) : null}
      </Button>
    </Col>
  );
};

export default WidgetTypeCard;
